import React, { useContext } from "react";
import { AttributesContext, AttributeGroupDataContext } from "../../../../contexts/attributes";
import { DisplayValue } from "./display-value";
import { SortableGroup } from "./sortable-group";

const DisplayGroup = ({ attribute, attributeList, readOnly, parentAttribute, uuid, onEditGroup, selectedId, setSelectedId, disabled, wipKey }) => {
    const attributes = useContext(AttributesContext);
    const attributeGroup = useContext(AttributeGroupDataContext);

    const isDraggableGroup = parentAttribute.key === "addressInfo" || parentAttribute.key === "preparationInstructionsInfo";

    const handleRemoveItem = (e, index) => {
        e.stopPropagation();
        const newValue = attributeGroup.data[uuid].reduce((arr, v, i) => {
            if (i !== index) {
                arr.push(v);
            }

            return arr;
        }, []);

        if (selectedId) {
            setSelectedId(null);
        }

        handleSave([...newValue]);
    };

    const handleSave = (newValue) => {
        attributeGroup.update(attribute, newValue);

        const parentValue = parentAttribute.uuid
            ? {
                  ...attributes.data[parentAttribute.uuid],
                  [uuid]: newValue,
              }
            : {};

        if (parentAttribute) {
            attributes.update(parentAttribute, {
                ...parentValue,
            });
        }
    };

    if (isDraggableGroup) {
        return (
            <SortableGroup
                attributeGroup={attributeGroup}
                attributeList={attributeList}
                attributeKey={parentAttribute.key}
                readOnly={readOnly}
                uuid={uuid}
                onSave={handleSave}
                onRemove={handleRemoveItem}
                onEditGroup={onEditGroup}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
                disabled={disabled}
                wipKey={wipKey}
            />
        );
    }

    return (
        <div>
            {attributeList.length > 0 &&
                attributeGroup.data[uuid].map((collection, index) => {
                    return (
                        <DisplayValue
                            key={`item_${index}`}
                            readOnly={readOnly}
                            disabled={disabled}
                            attributeList={attributeList}
                            collection={collection}
                            onRemoveItem={handleRemoveItem}
                        />
                    );
                })}
        </div>
    );
};

export default DisplayGroup;
